import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xux-tooltip',
  templateUrl: './xux-tooltip.component.html',
  styleUrls: ['./xux-tooltip.component.scss'],
})
export class XuxTooltipComponent {
  @Input() public label: string = '';
  @Input() public color: string = '';
  @Input() public count: number = 0;
  @Input() public top: number = 0;
  @Input() public left: number = 0;

  @HostBinding('style.top') public get topPx() {
    return `${this.top}px`;
  }
  @HostBinding('style.left') public get leftPx() {
    return `${this.left}px`;
  }
}
